import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Rafi9niCourse {
  id: number;
  name: string;
  arname: string;
}

export interface Rafi9niBatch {
  batchId: number;
  studentId: number;
  name?: string;
}

@Injectable({
  providedIn: 'root',
})
export class Rafi9niService {
  // Les APIs rafi9ni/educanet acceptent le CORS : Access-Control-Allow-Origin
  // reflète l'origine appelante (localhost:4200 comme parent2026.educanet.pro),
  // et `Access-Control-Allow-Credentials: true`. On peut donc les appeler
  // directement en absolu, SANS reverse-proxy, aussi bien en dev qu'en prod.
  //
  // Alternative "même origine" (sans CORS) : configurer un reverse-proxy sur le
  // serveur web (voir README-deploy.md) puis utiliser ces chemins relatifs :
  //   /rafi9ni-grade/*      -> https://mon-compte.educanet.pro/mobile/*
  //   /rafi9ni-mobile/*     -> https://mon-compte.rafi9ni.pro/mobile/*
  private readonly gradeBaseUrl = 'https://mon-compte.educanet.pro/mobile/';
  private readonly mobileBaseUrl = 'https://mon-compte.rafi9ni.pro/mobile/';
  private readonly staffBaseUrl = 'https://staff.rafi9ni.pro/';

  private http: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend);
  }

  getGradeById(gradeId: number): Observable<string> {
    return this.http.get(`${this.gradeBaseUrl}GetGradeById/${gradeId}`, {
      responseType: 'text',
    });
  }

  getCourses(digiref: number | string): Observable<any> {
    return this.http.get(`${this.mobileBaseUrl}homeWork/course/${digiref}`);
  }

  getBatchesByGrade(digiref: number | string): Observable<any> {
    return this.http.get(
      `${this.mobileBaseUrl}rafi9ni/ListBatchByGrade/${digiref}`
    );
  }

  getHomeWorks(
    batchId: number,
    studentId: number,
    courseId: number,
    page: number
  ): Observable<any> {
    return this.http.get(
      `${this.mobileBaseUrl}homeWork/getHomeWorkperpagettt/${batchId}/${studentId}/${courseId}/${page}/10`
    );
  }

  getHomeWorkDetails(idObs: number | string): Observable<any> {
    return this.http.get(
      `${this.mobileBaseUrl}homeWorks/getDetails/${idObs}`
    );
  }

  buildStaffFileUrl(newPath: string | undefined | null): string {
    const raw = (newPath || '').trim();
    if (!raw) return '';
    if (/^https?:\/\//i.test(raw)) return encodeURI(raw);

    let processed = raw;
    const webappsIndex = raw.indexOf('/webapps/');
    if (webappsIndex !== -1) {
      processed = raw.substring(webappsIndex + '/webapps'.length);
    }

    const cleaned = processed.replace(/^\/+/, '');
    return encodeURI(`${this.staffBaseUrl}${cleaned}`);
  }
}